const farmEquipmentList = [
    {
        "id": "alet1",
        "name": "Tulumba",
        "image": "",
        "info": ""
    },
    {
        "id": "alet2",
        "name":"Çapa",
        "image": "https://www.tarimtedarik.com/images/thumbs/000/0001763_y200-h-honda-benzinli-65-hp-capa-makinasi_625.jpeg",
        "info": ""
    },
    {
        "id": "alet3",
        "name":"Hortum",
        "image": "https://www.tarimmakinasi.com/wp-content/uploads/2021/01/ilaclama-makinesi-hortumu_0000010188.jpg",
        "info": ""
    },
    {
        "id": "alet4",
        "name":"Budama Makası",
        "image": "https://www.rtrmax.com/wp-content/uploads/2022/02/RH05812-budama-makasi.jpg",
        "info": ""
    },
    {
        "id": "alet5",
        "name":"Aşı Makası",
        "image": "https://st2.myideasoft.com/idea/aa/75/myassets/products/551/asi-makasi-budama-bag-agac-uzum.jpg?revision=1550150104",
        "info": ""
    },
    {
        "id": "alet6",
        "name":"Macun",
        "image": "https://www.hateksantarim.com/FileUpload/ep869593/UrunResim/48238212.jpg",
        "info": ""
    },
    {
        "id": "alet7",
        "name":"Testere",
        "image": "https://bultarim.com/wp-content/uploads/2020/11/Alpina-A-305C-Motorlu-Testere.jpg",
        "info": ""
    },
    {
        "id": "alet8",
        "name":"Elektrikli İlaçlama ",
        "image": "https://koctas-img.mncdn.com/mnresize/1200/1200/productimages/1000519441/1000519441_1_MC/8838238273586_1655289840159.jpg",
        "info": "Makinaları"
    },
    {
        "id": "alet9",
        "name":"Benzinli İlaçlama ",
        "image": "https://www.cdnaws.com/i/irfanbereketico/QvGYHLvkHpaZW3D2ZW3D2LvkHpaZW3D2ZW3D2/images/urunler/6099d0e34ce62-45026-1.png",
        "info": "Makinaları"
    },
    {
        "id": "alet10",
        "name":"Benzinli Sırt İlaçlama ",
        "image": "",
        "info": "Makinaları"
    },
    {
        "id": "alet11",
        "name":"Akülü Bahçe Makası",
        "image": "",
        "info": ""
    },
    {
        "id": "alet11",
        "name":"Akülü Sırt Tulumbası",
        "image": "https://www.camimarket.com/image/cache/catalog/Ev-Bahce/%C4%B0la%C3%A7lama/Pomilsan-cift-motorlu%C4%B1-Ak%C3%BCl%C3%BC-16LT-%C4%B0la%C3%A7lama-Pompas%C4%B1-elektronikse-com-550x550-750x750.jpg",
        "info": ""
    },
    {
        "id": "alet12",
        "name":"Tırpan Makinaları",
        "image": "",
        "info": ""
    },
]

export default farmEquipmentList; 